import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import GuestLayout from '../Layouts/GuestLayout'; // Adjust the import path as needed

const EmailVerified = () => {
    const [searchParams] = useSearchParams();
    const [isVerified, setIsVerified] = useState(false);

    useEffect(() => {
        if (searchParams.get('verified') === 'true') {
            setIsVerified(true);
        }
    }, [searchParams]);

    return (
        <GuestLayout>
            <div className="flex flex-col items-center justify-center text-center">
                {isVerified ? (
                    <>
                        <h1 className="text-2xl font-bold text-green-600 mb-4">
                            Η επιβεβαίωση του email σας ολοκληρώθηκε με επιτυχία!
                        </h1>
                        <Link to="/" className="mt-4 px-6 py-2 bg-blue-600 text-white rounded shadow hover:bg-blue-700">
                            Επιστροφή στην Αρχική
                        </Link>
                    </>
                ) : (
                    <>
                        <h1 className="text-2xl font-bold text-red-600 mb-4">
                            Κάτι πήγε στραβά με την επιβεβαίωση του email σας.
                        </h1>
                        <Link to="/" className="mt-4 px-6 py-2 bg-blue-600 text-white rounded shadow hover:bg-blue-700">
                            Επιστροφή στην Αρχική
                        </Link>
                    </>
                )}
            </div>
        </GuestLayout>
    );
};

export default EmailVerified;